import ApiClient from './ApiClient';

class TeamsClient {
  constructor(authToken, eventId) {
    this.apiClient = new ApiClient();
    this.gatewayUri = 'api/v1';
    this.latestVersion = 'v1';
    this.baseUri = process.env.VUE_APP_HACKATHON_SERVICE_URI;
    this.eventId = eventId;
    this.headers = {
      Authorization: `Bearer ${authToken}`,
    };
    this.params = {};
  }

  getTeams() {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams`, this.params, this.headers)
      .then((response) => response.data);
  }

  createTeam(newTeam) {
    const dataBody = {
      name: newTeam.name,
      description: newTeam.description,
    };
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams`, dataBody, this.headers)
      .then((response) => response.data);
  }

  joinTeam(teamId, joinCode) {
    const dataBody = {
      joinCode,
    };
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams/${teamId}`, dataBody, this.headers)
      .then((response) => response.data);
  }

  disbandTeam(teamId) {
    const dataBody = {};
    return this.apiClient.delete(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams/${teamId}`, dataBody, this.headers)
      .then((response) => response.data);
  }

  leaveTeam(teamId, userEmail) {
    const dataBody = {};
    return this.apiClient.delete(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams/${teamId}/${userEmail}`, dataBody, this.headers)
      .then((response) => response.data);
  }

  updateTeam(updatedTeam) {
    const dataBody = {
      name: updatedTeam.name,
      description: updatedTeam.description,
      memberOrder: updatedTeam.memberOrder,
    };
    return this.apiClient.put(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams/${updatedTeam.id}`, dataBody, this.headers)
      .then((response) => response.data);
  }

  promoteToLeader(teamId, userEmail) {
    const dataBody = {
      email: userEmail,
    };
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams/${teamId}/leader`, dataBody, this.headers)
      .then((response) => response.data);
  }

  setTeamFull(teamId) {
    const dataBody = {};
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams/${teamId}/full`, dataBody, this.headers)
      .then((response) => response.data);
  }

  setTeamNotFull(teamId) {
    const dataBody = {};
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams/${teamId}/notfull`, dataBody, this.headers)
      .then((response) => response.data);
  }

  addTeamPresentationLink(teamId, payload) {
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams/${teamId}/links`, payload, this.headers)
      .then((response) => response.data);
  }

  removeTeamPresentationLink(teamId, linkId) {
    return this.apiClient.delete(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/teams/${teamId}/links/${linkId}`, {}, this.headers)
      .then((response) => response.data);
  }
}
export default TeamsClient;
